import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import '@mantine/core/styles.css';
import './styles.css';
import './i18n/index.js';
import { App } from './App.js';
import { startSync } from './offline/sync.js';
import { driverTheme } from '@prooffleet/ui';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Данные во дворе меняются редко, а сеть дорогая: не дёргаем лишний раз.
      staleTime: 60_000,
      retry: (failureCount) => navigator.onLine && failureCount < 2,
      refetchOnWindowFocus: false,
    },
  },
});

startSync();

const container = document.getElementById('root');
if (container === null) throw new Error('Не найден корневой элемент');

createRoot(container).render(
  <StrictMode>
    <MantineProvider theme={driverTheme} defaultColorScheme="auto">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </MantineProvider>
  </StrictMode>,
);
